module.exports = __webpack_public_path__ + "fonts/CormorantUpright-Bold.7f40b2b.ttf";